(ns app.front.ui.split)

(def header-element
  :h4.uppercase.pb-2)

(defn split-pane [{:keys [left-title right-title]} left-content right-content]
  [:div.md:flex
   [:div.flex-1.md:pr-4
    [header-element
     left-title]
    [:div
     left-content]]
   [:div.flex-1.flex.flex-col
    [header-element {:class "pt-2 md:pt-0 md:pl-4"}
     right-title]
    [:div.md:border-l-2.border-solid.border-ui-gray.md:pl-4.flex-1
     right-content]]])
